export const CHECKOUT_PASSWORDLESS_VERSION = "checkout-v2-passwordless";

export const getJusbillSubscriptionPath = ({ paymentMethod }) =>
  paymentMethod === "pix" ? "/subscriptions/pix/v2" : "/subscriptions/v2";

export const buildCheckoutValues = ({ values, cardHash, urlParams }) => ({
  ...values,
  ...(cardHash !== undefined ? { card_hash: cardHash } : {}),
  ...(urlParams !== undefined ? { urlParams } : {}),
  version: CHECKOUT_PASSWORDLESS_VERSION,
});

export const resolveCheckoutPlanId = ({ coupom, plan }) => {
  // cupom válido não implica plan_id: o tier selecionado pode não ter
  // cupom no catálogo (buildCatalogCheckoutCoupom devolve plan_id undefined nesse caso), sem que
  // isso seja um erro — cai pro gateway_id do plano, mesmo caminho de "sem cupom".
  if (coupom?.is_valid && coupom.plan_id) {
    return coupom.plan_id;
  }

  if (
    plan?.gateway_id === undefined ||
    plan?.gateway_id === null ||
    plan?.gateway_id === ""
  ) {
    throw new Error("Plano sem gateway_id");
  }

  return String(plan?.gateway_id);
};

export const buildCheckoutRegisterPayload = ({ values }) => {
  // O form do /cadastro mantém password/confirmation_password (o modo
  // infoprodutor pede senha); o cadastro no Jusbill nunca leva senha.
  const {
    card_number: _,
    card_cvv: __,
    card_expiration: ___,
    card_hash,
    urlParams,
    version,
    password,
    confirmation_password,
    ...registerValues
  } = values;

  return {
    ...registerValues,
    card_hash,
    urlParams,
    version: CHECKOUT_PASSWORDLESS_VERSION,
    requires_first_access: true,
  };
};
